// extracted by mini-css-extract-plugin
export default {"countCell":"DivisionCountCell_countCell__doXrO"};